import { Component } from '@angular/core';

@Component({
    selector: 'sh-regex-tooltip-content',
    templateUrl: './regex-tooltip-content.component.html',
})
export class RegexTooltipContentComponent {

}
